@if (!legacyService?.getLegacyMode()) {
<mat-card style="display: none"></mat-card>
}
<ng-content></ng-content>
